import { useEffect, useRef, useState } from "react";

import QueryModal from "views/components/QueryModal";
import QueryModalInput from "views/components/QueryModal/QueryModalInput";
import QueryModalTitle from "views/components/QueryModal/QueryModalTitle";
import SubmitQueryButton from "views/components/QueryModal/SubmitQueryButton";

import CaptionIcon from "assets/icons/CaptionIcon";
import styles from "./style.module.scss";
import {
  createAndUpdateCaptionFilter,
  isVqlQuery,
} from "helpers/utility/vqlHelpers";
import useVqlParams from "hooks/useVqlParams";
import { VqlQuery } from "types";
import { Filters } from "types";
import { useDispatch } from "react-redux";
import { setSelectedQueryModal } from "redux/SingleDataset/actions";
import { useTextQueryModal } from "hooks/UseQueryModal/useTextQueryModal";

interface CaptionQueryModalProps {
  editQueryId?: string;
}

export default function CaptionQueryModal({
  editQueryId,
}: CaptionQueryModalProps) {
  const { findVqlQuery, addVqlQuery, updateVqlQuery, vqlQueries } =
    useVqlParams();

  const oldQuery = editQueryId ? findVqlQuery(editQueryId, "text") : null;
  const previousValue = oldQuery?.text?.value || "";

  const [searchText, setSearchText] = useState(previousValue);
  const modalRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const query = vqlQueries.find(
      (query: VqlQuery) => isVqlQuery(query, "text") && query.text.op === "fts"
    );
    if (query) {
      dispatch(setSelectedQueryModal({ type: Filters.CAPTION, id: query.id }));
    } else {
      dispatch(setSelectedQueryModal({ type: Filters.CAPTION }));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSearchText(previousValue);
    // eslint-disable-next-line
  }, [editQueryId]);

  const { isSubmitDisabled } = useTextQueryModal({
    inputValue: searchText,
    previousValue,
    editQueryId,
  });

  const handleSubmission = () => {
    if (isSubmitDisabled) {
      return;
    }

    const vqlQuery = createAndUpdateCaptionFilter(searchText, editQueryId);
    editQueryId ? updateVqlQuery(vqlQuery) : addVqlQuery(vqlQuery);
    dispatch(setSelectedQueryModal(null));
  };

  const handleInputChange = (value: string) => {
    setSearchText(value);
  };

  return (
    <QueryModal modalRef={modalRef}>
      <QueryModalTitle icon={<CaptionIcon type="IMAGE" />}>
        Caption
      </QueryModalTitle>
      <div className={styles.filterContent}>
        <QueryModalInput
          searchText={searchText}
          onInputChange={handleInputChange}
        />

        <SubmitQueryButton
          isDisabled={isSubmitDisabled}
          onSubmit={handleSubmission}
        />
      </div>
    </QueryModal>
  );
}
